export default __webpack_public_path__ + "static/media/admin2.4f7c7433.png";